<template>
  <v-card>
    <v-toolbar dark class="primary">
      <v-btn icon @click.native="close" dark>
        <v-icon>fa-times</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>

      <v-tabs grow v-model="active_tab" slider-color="primary">
        <v-tab ripple key="0">Ogólne</v-tab>
        <v-tab ripple key="1" v-show="this.id > 0 && !this.parentId">Podtypy</v-tab>
        <v-tab-item key="0">
          <v-container fluid>
            <v-row no-gutters>
              <v-col cols="12">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-container>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-text-field label="Nazwa" v-model="nazwa" :rules="[nazwa_rules.required, nazwa_rules.min_length]"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Domyślna długość wizyty" v-model.number="dlugoscWizyty" :rules="[dlugosc_wizyty_rules.numbers, dlugosc_wizyty_rules.min]" type="number"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field label="Cena (zł)" v-model.number="cena" :rules="[dlugosc_wizyty_rules.numbers]" type="number" @input="handleInput"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="6">
                        <label>Przypisany kolor</label>
                        <ColorPicker :color="kolor" v-model="kolor"/>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-checkbox v-model="aktywny" label="Czy aktywny?" :readonly="this.id == 0"></v-checkbox>
                      </v-col>
                      <v-col cols="6">
                        <v-checkbox v-model="blokujeTerapeute" label="Czy blokować terapeute?"></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row v-if="kategorie && kategorie.length > 0">
                      <v-col cols="12">
                        <v-select :items="kategorie" v-model="wybranaKategoria" label="Wybierz kategorie" item-text="nazwa"  return-object clearable></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-card>
                          <v-toolbar flat color="white">
                            <v-toolbar-title>Kategorie ICD9</v-toolbar-title>
                          </v-toolbar>
                          <v-card-text>
                            <v-list>
                              <v-list-item v-for="(item,index) in kody" :key="index">
                                <v-list-item-content>
                                  {{item.icD9_Kod + ' - '+item.icD9_Opis}}
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-icon small @click="removeIcd9(item.icD9_Kod)" title="Usuń kategorie">fa-trash-alt</v-icon>
                                </v-list-item-action>
                              </v-list-item>
                            </v-list>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="pickICD" class="ml-3">Dodaj</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row v-if="placowki != null && placowki.length > 0">
                      <v-col cols="12">
                        <v-card>
                          <v-toolbar flat color="white">
                            <v-toolbar-title>Przypisane placówki</v-toolbar-title>
                          </v-toolbar>
                          <v-card-text>
                            <v-container fluid>
                              <v-row v-if="placowki != null && placowki.length > 0">
                                <v-col cols="12">
                                  <v-list>
                                    <v-list-item v-for="(item,index) in selectedAdditionalOutposts" :key="index">
                                      <v-list-item-content>
                                        {{item.name}}
                                      </v-list-item-content>
                                      <v-list-item-action>
                                        <v-icon small @click="removeAdditionalOutpost(item)" title="Usuń placówke">fa-trash-alt</v-icon>
                                      </v-list-item-action>
                                    </v-list-item>
                                  </v-list>
                                </v-col>
                              </v-row>
                              <v-row v-if="availableOutposts != null && availableOutposts.length > 0">
                                <v-col cols="8">
                                  <v-select :items="availableOutposts" v-if="availableOutposts && availableOutposts.length > 0" label="Placówka" placeholder="Wybierz placówke..." item-text="name" v-model="additionalOutpost" name="role" id="role" return-object>
                                  </v-select>
                                </v-col>
                                <v-col cols="4">
                                  <v-btn color="primary" @click="addAdditionalOutpost">Dodaj placówke</v-btn>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-textarea v-model="uwagi" label="Uwagi"></v-textarea>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="1">
          <v-container fluid>
            <v-row>
              <v-row no-gutters>
                <v-col cols="12" align-self="end">
                  <v-btn color="info" @click="addNewPodTyp"  v-if="$can('do','POKO_WizytyZabiegi_Edycja')">Dodaj podtyp</v-btn>
                </v-col>
              </v-row>
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-data-table
                        :items="podtypy"
                        :headers="headers"
                        hide-default-footer
                        disable-pagination
                        style="margin-bottom:200px"
                    >
                      <template v-slot:item="props">
                        <tr>
                          <td>{{props.item.nazwa}}</td>
                          <td>{{props.item.dlugoscWizyty}}</td>
                          <td>{{props.item.aktywny ? 'Tak' : 'Nie'}}</td>
                          <td>
                            <v-icon small class="mr-2" @click="editPodtyp(props.item.id)" v-if="$can('do','POKO_WizytyZabiegi_Edycja')" title="Edytuj podtyp">fa-edit</v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
              </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="close" color="error">Zamknij</v-btn>
      <v-btn color="success" @click="save">Zapisz</v-btn>
    </v-card-actions>
    <ICD9PIcker v-if="showAddIcd9" :visible="showAddIcd9" @close="showAddIcd9 = false" @category_selected="categorySelected"></ICD9PIcker>
    <v-dialog width="900px" v-if="showAddPodTyp" v-model="showAddPodTyp" persistent>
      <PodtypEdit :id="podtypid" :rodzic="id" v-if="showAddPodTyp" @close="showAddPodTyp = false" @saved="savedPodtyp"></PodtypEdit>
    </v-dialog>
  </v-card>
</template>

<script>
import ICD9PIcker from "@/components/visits/ICD9PIcker";
import ColorPicker from "@/components/shared/ColorPicker";
import {zabiegiService} from "@/services";
import swal from "sweetalert";
import PodtypEdit from "@/components/zabiegi/PodtypEdit";
export default {
  name: "ZabiegEdit",
  components: {PodtypEdit, ColorPicker, ICD9PIcker},
  props: ['id','kategorie','placowki'],
  data() {
    return {
      valid: true,
      nazwa: '',
      kolor: '',
      podtypid: 0,
      showAddPodTyp: false,
      cena: 0,
      active_tab: 0,
      previousPrice: 0,
      aktywny: true,
      uwagi: '',
      dlugoscWizyty: 30,
      blokujeTerapeute: false,
      wybranaKategoria: null,
      wybranaPlacowka: null,
      kody: [],
      podtypy: [],
      selectedAdditionalOutposts: [],
      additionalOutpost: null,
      title: 'Dodawanie zabiegu',
      parentId: null,
      nazwa_rules: {
        required: value=> !!value || 'Nazwa jest wymagana',
        min_length: value=> !(value && value.length < 3) || 'Nazwa musi posiadać minimum 3 znaki'
      },
      dlugosc_wizyty_rules: {
        numbers: value => !isNaN(value) || 'Długośc wizyty musi być liczbą całkowita',
        min: value => Number(value) > 0 || 'Długośc wizyty musi być większa od 0'
      },
      cena_rules: {
        numbers: value => !isNaN(value) || 'Cena musi być liczbą',
        min: value => Number(value) > 0 || 'Cena nie może być mniejsza od 0'
      },
      showAddIcd9: false,
      headers: [
        {text: 'Nazwa zabiegu',  align: 'left', value: 'nazwa'},
        {text: 'Długośc wizyty',  align: 'left', value: 'dlugoscWizyty'},
        {text: 'Aktywny', align: 'left', value: 'aktywny'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
    }
  },

  mounted() {

    if(this.id && this.id > 0)
    {
        zabiegiService.getZabiegDetails(this.id).then(result => {
          let details = result.data.result
          this.nazwa = details.nazwa
          this.cena = details.cena
          this.dlugoscWizyty = details.dlugoscWizyty
          this.icD9_Opis = details.icD9_Opis
          this.icD9_Kod = details.icD9_Kod
          this.kolor = details.kolor
          this.uwagi = details.uwagi
          this.aktywny = details.aktywny
          this.kody = details.kody
          this.blokujeTerapeute = details.blokujeTerapeute
          this.parentId = details.parentId
          this.podtypy = details.podtypy ? details.podtypy : []
          this.title = 'Edycja zabiegu: '+this.nazwa
          this.wybranaKategoria = this.kategorie.find(x=>x.id == details.kategoriaId)

          if(this.placowki != null && this.placowki.length > 0)
          {
            if(details.additionalOutposts && details.additionalOutposts.length > 0)
            {

              details.additionalOutposts.forEach(elem => {
                let itm = this.placowki.find(x=>x.id == elem)
                if(itm != null)
                  this.selectedAdditionalOutposts.push(itm)
              })
            }
          }
        }).catch(() => {
          this.showError(true,'Błąd pobrania zabiegu')
        })
    }
  },
  computed: {
    availableOutposts: function() {
      if(this.selectedAdditionalOutposts && this.placowki)
      {
        return this.placowki.filter(x=> !this.selectedAdditionalOutposts.find(z=> z.id == x.id))
      }
      return this.placowki
    }
  },
  methods: {
    removeAdditionalOutpost(outpost) {
      this.selectedAdditionalOutposts = this.selectedAdditionalOutposts.filter(x=>x.id != outpost.id)
    },
    addAdditionalOutpost(){
      this.selectedAdditionalOutposts.push(this.additionalOutpost)
    },
    loadZabieg()
    {
      if(this.id && this.id > 0)
      {
        zabiegiService.getZabiegDetails(this.id).then(result => {
          let details = result.data.result
          this.nazwa = details.nazwa
          this.cena = details.cena
          this.dlugoscWizyty = details.dlugoscWizyty
          this.icD9_Opis = details.icD9_Opis
          this.icD9_Kod = details.icD9_Kod
          this.kolor = details.kolor
          this.uwagi = details.uwagi
          this.aktywny = details.aktywny
          this.kody = details.kody
          this.blokujeTerapeute = details.blokujeTerapeute
          this.parentId = details.parentId
          this.podtypy = details.podtypy ? details.podtypy : []
          this.wybranaKategoria = this.kategorie.find(x=>x.id == details.kategoriaId)
          if(this.placowki != null && this.placowki.length > 0)
          {
            this.wybranaPlacowka = this.placowki.find(x=>x.id == details.additionalOutpostId)
          }
        }).catch(() => {
          this.showError(true,'Błąd pobrania zabiegu')
        })
      }
    },
    savedPodtyp() {
      this.loadZabieg()
      this.showAddPodTyp = false
    },
    editPodtyp(id)
    {
      this.podtypid = id
      this.showAddPodTyp = true
    },
    addNewPodTyp() {
      this.podtypid = 0
      this.showAddPodTyp = true
    },
    handleInput (e) {
      let stringValue = e
      let regex = /^\d*(\,\d{1,2})?$/
      if(!stringValue.match(regex) && this.cena!== '') {
        this.cena = this.previousPrice
      }
      this.previousPrice = this.cena
    },
    close()
    {
      this.$emit('close')
    },
    save()
    {
      if(this.$refs.form.validate())
      {
        let outposts = []
        if(this.selectedAdditionalOutposts && this.selectedAdditionalOutposts.length > 0)
        {
          this.selectedAdditionalOutposts.forEach(elem => {
            outposts.push(elem.id)
          })
        }

        if(this.id == 0)
        {
          zabiegiService.insertZabieg({
            kolor: this.kolor,
            nazwa: this.nazwa,
            icD9_Kod: this.icD9_Kod,
            icD9_Opis: this.icD9_Opis,
            cena: this.cena,
            aktywny: this.aktywny,
            uwagi: this.uwagi,
            dlugoscWizyty: this.dlugoscWizyty,
            kody: this.kody,
            blokujeTerapeute: this.blokujeTerapeute,
            kategoriaId: this.wybranaKategoria && this.wybranaKategoria.id > 0 ? this.wybranaKategoria.id : null,
            additionalOutposts: outposts
          }).then(() => {
            this.$emit('saved')
          }).catch((e)=> {

            if (
                e.response != null &&
                e.response.data != null &&
                e.response.data.error != null
            ) {
              this.showError(false,e.response.data.error.message)
            } else {
              this.showError(false,'Błąd zapisu zabiegu')
            }

          })
        }
        else
        {
          zabiegiService.updateZabieg({
            id: this.id,
            kolor: this.kolor,
            nazwa: this.nazwa,
            icD9_Kod: this.icD9_Kod,
            icD9_Opis: this.icD9_Opis,
            cena: this.cena,
            aktywny: this.aktywny,
            uwagi: this.uwagi,
            dlugoscWizyty: this.dlugoscWizyty,
            kody: this.kody,
            blokujeTerapeute: this.blokujeTerapeute,
            kategoriaId: this.wybranaKategoria && this.wybranaKategoria.id > 0 ? this.wybranaKategoria.id : null,
            additionalOutposts: outposts
          }).then(() => {
            this.$emit('saved')
          }).catch(()=> {
            this.showError(false,'Błąd zapisu zabiegu')
          })
        }
      }
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    pickICD()
    {
      this.showAddIcd9 = true
    },
    categorySelected(cat)
    {
      this.showAddIcd9 = false

      let itm = this.kody.find(x=>x.icD9_Kod == cat.kod)
      if(itm == null)
      {
        let newItem = {
          id: 0,
          icD9_Kod: cat.kod,
          icD9_Opis: cat.kod_opis
        };
        this.kody.push(newItem)
      }
    },
    removeIcd9(kod)
    {
      let filterOut = this.kody.filter(e=> e.icD9_Kod !== kod)
      this.kody = filterOut
    }
  }
}
</script>

<style scoped>

</style>